// hooks/table/configs/useSelectSupplierProductsOnProduct.ts
import { useEffect, useState } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { useTableSettings } from '../tableSettings/useTableSettings';
import { useTableSelector } from '../tableSettings/useTableSelector';
import { useGetAllSupplierProducts } from 'src/hooks/api/requestConfigs/purchasing';
import { supplierProductTableByIdColumns } from './useSupplierProductsTable';
import useUpdateEffect from 'src/hooks/useUpdateEffect';

export function useSupplierProductsOnProductTable(
  rows: any[]
): readonly [GridColDef[] | any, ReturnType<typeof useTableSettings>] {
  const columns = supplierProductTableByIdColumns();
  const tableSettings = useTableSettings({
    columns,
    rows,
    idPath: ['SupplierAssortmentItemId'],
    tableName: 'SupplierProductsOnProductTable',
  });
  tableSettings.autoHeight = true;
  tableSettings.loading = false;
  tableSettings.hasToolbar = false;
  useEffect(() => {
    tableSettings.setColumnVisibilityModel({
      ManufacturerProduct_Key: false,
      Manufacturer_Key: false,
      UpdatedAt: false,
      OrganizationCurrency_Key: false,
      SupplierAssortment_Key: false,
    });
  }, []);
  
  return [columns, tableSettings] as const;
}

export function useSupplierProductsSelectTable(): readonly [GridColDef[] | any, ReturnType<typeof useTableSettings>] {
  const {rows,status} = useGetAllSupplierProducts();
  const columns = supplierProductTableByIdColumns();
  const tableSettings = useTableSettings({
    columns,
    rows,
    status,
    idPath: ['SupplierAssortmentItemId'],
    tableName: 'SupplierProductsSelectTable',
    hasToggleMenu: true,
  });

  return [columns, tableSettings] as const;
}


export function useSelectSupplierProductsOnProduct(
  initialValues: any
): readonly [
  GridColDef[] | any,
  ReturnType<typeof useTableSettings>,
  any[],
  ReturnType<typeof useTableSelector>
] {
  const [rows, setRows] = useState<any[]>(initialValues?.SupplierProducts ?? []);

  const [displayCols, displaySettings] = useSupplierProductsOnProductTable(rows);
  const [selectCols, selectSettings] = useSupplierProductsSelectTable();

  const selector = useTableSelector({
    rows,
    setRows,
    selectGrid: [selectCols, selectSettings],
    getId: row => row.SupplierAssortmentItemId,
  });
  

  useUpdateEffect(() => {
    if (rows?.length < 1) {
      setRows(initialValues?.SupplierProducts ?? [])
    }
  }, [initialValues?.SupplierProducts])

  useUpdateEffect(() => {
    if (selectSettings?.allRows?.length > 0 && initialValues?.Manufacturer_Value) {

      selectSettings.setFilterModel({
        items: [
          { field: 'Manufacturer_Value', operator: 'equals', value: initialValues?.Manufacturer_Value },
          { field: 'Product_Key', operator: 'isEmpty', value: undefined },
        ],
      });
    }
  }, [initialValues?.Manufacturer_Value]);

  return [displayCols, displaySettings, rows, selector] as const;
}
